import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/img/icon-notice.svg'
import _imports_1 from '@/assets/img/logo.svg'


const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "column -notifications" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "通知マーク"
}, null, -1)
const _hoisted_5 = {
  key: 0,
  class: "circle"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text" }, "お知らせ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "YUME PRO",
  style: {"width":"70%","height":"70%"}
}, null, -1)
const _hoisted_8 = { class: "column -menu" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "text" }, "メニュー", -1)

import { computed, onBeforeUpdate, onMounted } from 'vue'
import { RouterLink } from 'vue-router'

import Menu from '@/components/MenuComponent.vue'
import { getNgWords } from '@/logic/validator/ngWord'
import { useStore } from '@/store/useStore'

export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderComponent',
  setup(__props) {

const store = useStore()
const isSignedIn = computed(() => store.state.signedIn)
const unreadNotificationCount = computed(() => store.state.notificationCount)

onMounted(async () => {
  // リロード時に自身のユーザ情報を取得して、storeに保存
  await getUserDetail()
  // NGワードをstoreで保持
  const ngWords = await getNgWords(1, store)
  store.commit('setNgWords', ngWords)
  if (isSignedIn.value) {
    try {
      // 通知未読件数
      await store.dispatch('getUnreadNotificationCount')
    } catch (error) {
      console.error(error)
    }
  }
})

// NOTE:onMounted()ではisSignedInの更新が反映されないため onBeforeUpdate()を使用
onBeforeUpdate(async () => {
  if (isSignedIn.value) {
    try {
      // 通知未読件数
      await store.dispatch('getUnreadNotificationCount')
    } catch (error) {
      console.error(error)
    }
  }
})

const getUserDetail = async () => {
  isSignedIn.value &&
    (await store.dispatch('getUserDetail').catch(() => {
      // user情報が取得できない場合はログアウト
      store.dispatch('logout')
    }))
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (isSignedIn.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_unref(RouterLink), {
                  to: { name: 'notifications' },
                  class: "link"
                }, {
                  default: _withCtx(() => [
                    _hoisted_4,
                    (unreadNotificationCount.value > 0)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_5))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _hoisted_6
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_unref(RouterLink), {
          to: { name: 'home' },
          class: "logo",
          style: {"display":"flex","align-items":"center","justify-content":"center"}
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(Menu),
          _hoisted_9
        ])
      ])
    ])
  ]))
}
}

})